import { render, staticRenderFns } from "./HsnTsnForm.vue?vue&type=template&id=733563c6&"
import script from "./HsnTsnForm.vue?vue&type=script&lang=js&"
export * from "./HsnTsnForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports